/*! Wi-tasks - v0.0.2
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode;
 */


var url_task, url_save_task, url_delete_task, url_tasks;

+function ($) {
    'use strict';

    const wiTasks = window.wiTasks = {
        init() {
            this.events.init();
        },

        events: {
            init() {
                // Show task modal (comments)
                $(document).on('show.bs.modal', '#view_task', function () {
                    wiComments.get.comments();
                });

                // Load tasks via tab
                $(document).on('show.bs.tab', '.tab-tasks', function () {
                    const target = $(this).data('target');
                    const $target = $(target);

                    if (!$target.data('ajax-loaded')) {
                        wiVars.set.from.object($target);
                        $target.data('ajax-loaded', true);
                        wiTasks.get();
                    }
                });

                // Add task
                $(document).on('click', '.task-add', function (e) {
                    e.preventDefault();
                    const target = $(this).data('target');
                    wiVars.set.from.object($(target));
                    wiModal.get({
                        modal: 'add_task',
                        module: 'tasks',
                        url: 'tasks',
                        language_id,
                        referral_id,
                        referral_type
                    });
                });

                // Edit task
                $(document).on('click', '.task-edit', function (e) {
                    e.preventDefault();
                    const task_id = $(this).data('task-id');
                    wiVars.set.from.object($(this));
                    wiModal.get({
                        modal: 'edit_task',
                        module: 'tasks',
                        url: 'tasks',
                        language_id,
                        referral_id,
                        referral_type,
                        task_id
                    });
                });

                // View task (and set comment vars)
                $(document).on('click', '.task-view', function (e) {
                    e.preventDefault();
                    const task_id = $(this).data('task-id');
                    wiVars.set.from.object($(this));

                    comment_referral_id = task_id;
                    comment_referral_type = 'tasks';

                    wiVars.set.variable('comment_referral_id', comment_referral_id);
                    wiVars.set.variable('comment_referral_type', comment_referral_type);

                    wiActivity.setReaded(
                        this.getAttribute('data-referral-id'),
                        this.getAttribute('data-referral-type'),
                        this.getAttribute('data-subreferral-id'),
                        this.getAttribute('data-subreferral-type'),
                        this.getAttribute('data-type'),
                    );

                    wiModal.get({
                        modal: 'view_task',
                        module: 'tasks',
                        url: 'tasks',
                        language_id,
                        referral_id,
                        referral_type,
                        task_id
                    });
                });

                // Confirm delete task
                $(document).on('click', '.task-confirm-delete', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const task_id = $(this).data('task-id');
                    wiVars.set.from.object($(this));

                    wiModal.get({
                        modal: 'task_delete_confirmation',
                        module: 'tasks',
                        url: 'tasks',
                        task_id,
                        language_id,
                        referral_id,
                        referral_type
                    });
                });

                // Delete task action
                $(document).on('click', '#task_delete_btn', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const formData = $('#task_delete_form').serialize();
                    $.post(url_delete_task, formData, function (jData) {
                        $('#task_delete_confirmation').modal('hide');
                        wiVars.set.from.response(jData);
                        wiAlerts.add(jData.status, jData.title, jData.msg);
                        wiTasks.get();
                    });
                });

                // Save task
                $(document).on('click', '#task_save_btn', function (e) {
                    e.preventDefault();

                    const $btn = $(this);
                    const $form = $('#form_task');
                    const modalSelector = $btn.data('modal');
                    const $icon = $btn.find('.fa-spinner');

                    if (!$form.length) return;

                    $btn.prop('disabled', true);
                    $icon.removeClass('hidden');

                    const formEl = $form.get(0);
                    const formData = new FormData(formEl);

                    formData.delete('userfiles[]');
                    const files = window.fileStore.get(formEl) || [];
                    files.forEach(file => formData.append('userfiles[]', file));

                    fetch(url_save_task, {
                        method: 'POST',
                        body: formData
                    })
                        .then(res => res.json())
                        .then(jData => {
                            if (jData.status === 'success') {
                                wiTasks.get();
                                $(modalSelector).modal('hide');
                            }

                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        })
                        .catch(err => {
                            console.error('Task save failed', err);
                        })
                        .finally(() => {
                            $btn.prop('disabled', false);
                            $icon.addClass('hidden');
                        });
                });
            }
        },

        get() {
            $.get(url_tasks, {
                language_id,
                referral_id,
                referral_type,
                csrf_wicode: csrf_value
            }, function (data) {
                $('#tasks_area').html(data.tasks);
                if (typeof wiActivity !== 'undefined') {
                    wiActivity.get(referral_id, referral_type);
                }
            });
        },

        post() {
            $.post(url_tasks, {
                language_id,
                referral_id,
                referral_type,
                subreferral_id,
                subreferral_type,
                csrf_wicode: csrf_value
            }, function (data) {
                $('#tasks_area').html(data.tasks);
            });
        }
    };

    // Init URLs and run
    $(function () {
        url_task = urls.tasks;
        url_save_task = `${urls.tasks}/save_task`;
        url_delete_task = `${urls.tasks}/delete_task`;
        url_tasks = `${urls.tasks}/get_tasks`;

        wiTasks.init();
    });
}(jQuery);